import { render, staticRenderFns } from "./PlatMapInfo.vue?vue&type=template&id=13011b35&scoped=true&"
import script from "./PlatMapInfo.vue?vue&type=script&lang=js&"
export * from "./PlatMapInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlatMapInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PlatMapInfo.vue?vue&type=style&index=1&id=13011b35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13011b35",
  null
  
)

export default component.exports